export default __webpack_public_path__ + "static/media/potfolio.4b0e2028.png";